import * as geolib from "geolib";
import { Plugins } from "@capacitor/core";

import Vue from "vue";

import mAnalytics from "@/modules/analytics";
import mApp from "@/modules/app";
import mDialog from "@/modules/dialog";
import mMember from "@/modules/member";
import mOrder from "@/modules/order";
import mRest from "@/modules/rest";
import mStore from "@/modules/store";
import mUtils from "@/modules/utils";
import { APP_MODE } from "@/modules/enums";
import { ORDER_TYPE } from "@/modules/enums";

export default {
  data() {
    return {
      inputRules: {
        required: value => !!value || "Required",
        vcode: value => !!value || "Verification code is required",
        email: value => {
          return this.$isValidEmail(value) || "Invalid e-mail";
        },
        emailOpt: value => {
          return !value || this.$isValidEmail(value) || "Invalid e-mail";
        },
        phone: value => {
          return this.$isValidPhoneNumber(value) || "Invalid phone number";
        },
        phoneOpt: value => {
          return !value || this.$isValidPhoneNumber(value) || "Invalid phone number";
        },
        postal: value => {
          return this.$isValidPostal(value) || "Invalid postal code";
        },
        postalOpt: value => {
          return !value || this.$isValidPostal(value) || "Invalid postal code";
        },
      },

      test11: "",
    };
  },

  computed: {
    deliveryAddressString() {
      return mUtils.addressToString(this.$store.state.Order.order.address, " ");
    },

    storeAddressString() {
      return mUtils.addressToString(this.$store.getters.storeAddress, " ");
    },
  },

  methods: {
    getCovidFormSubmitTime() {
      let time = null;
      let key = "CTF_" + this.$store.getters.storeCompanyCode;
      if (localStorage.getItem(key)) {
        time = mUtils.toDate(localStorage.getItem(key));
      }

      return time;
    },

    setCovidFormSubmitTime() {
      let key = "CTF_" + this.$store.getters.storeCompanyCode;
      localStorage.setItem(key, Date());
    },

    getLastLogin() {
      let that = this;
      return new Promise(function (resolve) {
        let key = "LOC_" + that.$store.getters.storageKey;
        that.$idb.setting
          .get(key)
          .then(record => resolve(record.value))
          .catch(() => resolve(null));
      });
    },

    cartOnRightShown() {
      return (
        this.$vuetify.breakpoint.mdAndUp &&
        (this.$store.state.Order.order.orderType != ORDER_TYPE.DINEIN || !this.$store.getters.storeDineinMenuMode) &&
        (this.$router.currentRoute.name == "MenuFull" ||
          this.$router.currentRoute.name == "MenuCategory" ||
          (this.$router.currentRoute.name == "MenuItem" && this.$router.currentRoute.params.getNewBundleItem == null))
      );
    },

    setTheme(theme) {
      if (theme == null) return;

      //this.$vuetify.theme.dark = false;
      if ("primary" in theme) {
        this.$vuetify.theme.themes.light.primary = theme.primary;
        this.$vuetify.theme.themes.dark.primary = theme.primary;
      }
      if ("secondary" in theme) {
        this.$vuetify.theme.themes.light.secondary = theme.secondary;
        this.$vuetify.theme.themes.dark.secondary = theme.secondary;
      }
      if ("accent" in theme) {
        this.$vuetify.theme.themes.light.accent = theme.accent;
        this.$vuetify.theme.themes.dark.accent = theme.accent;
      }
      if ("info" in theme) {
        this.$vuetify.theme.themes.light.info = theme.info;
        this.$vuetify.theme.themes.dark.info = theme.info;
      }
      if ("success" in theme) {
        this.$vuetify.theme.themes.light.success = theme.success;
        this.$vuetify.theme.themes.dark.success = theme.success;
      }
      if ("warning" in theme) {
        this.$vuetify.theme.themes.light.warning = theme.warning;
        this.$vuetify.theme.themes.dark.warning = theme.warning;
      }
      if ("error" in theme) {
        this.$vuetify.theme.themes.light.error = theme.error;
        this.$vuetify.theme.themes.dark.error = theme.error;
      }
      if ("primaryText" in theme) {
        this.$vuetify.theme.themes.light.primaryText = theme.primaryText;
        this.$vuetify.theme.themes.dark.primaryText = theme.primaryText;
      }
      if ("secondaryText" in theme) {
        this.$vuetify.theme.themes.light.secondaryText = theme.secondaryText;
        this.$vuetify.theme.themes.dark.secondaryText = theme.secondaryText;
      }
      if ("accentText" in theme) {
        this.$vuetify.theme.themes.light.accentText = theme.accentText;
        this.$vuetify.theme.themes.dark.accentText = theme.accentText;
      }
      if ("infoText" in theme) {
        this.$vuetify.theme.themes.light.infoText = theme.infoText;
        this.$vuetify.theme.themes.dark.infoText = theme.infoText;
      }
      if ("warningText" in theme) {
        this.$vuetify.theme.themes.light.warningText = theme.warningText;
        this.$vuetify.theme.themes.dark.warningText = theme.warningText;
      }

      if (theme.primary) {
        let ele = document.querySelector('meta[name="theme-color"]');
        if (ele) {
          /*
          let styles = getComputedStyle(document.documentElement);        
          let primaryColor = styles.getPropertyValue("--v-primary-base");
          */
          ele.setAttribute("content", theme.primary);
        }
      }
    },

    setNextLanguage() {
      if (this.$store.getters.languages.length <= 1) return;

      let langIndex = this.$store.getters.languages.indexOf(this.$store.state.languageSelected);
      let nextLang = this.$store.state.languageSelected;
      if (this.$store.getters.languages.length == langIndex + 1) nextLang = this.$store.getters.languages[0];
      else nextLang = this.$store.getters.languages[langIndex + 1];

      this.setLanguage(nextLang);
    },

    // getDistance({ latitude: 51.5103, longitude: 7.49347 }, { latitude: "51° 31' N", longitude: "7° 28' E" });
    getDistance(coords1, coords2) {
      let distance = geolib.getDistance(coords1, coords2);
      return distance;
    },

    getCoords(address) {
      var addressObj = {
        address_line_1: address,
        //address_line_2: "",
        //city: "",
        //state: "CA", // province also valid
        //zip_code: "94043", // postal_code also valid
        //country: "",
      };
      console.log(addressObj);

      //let that = this;
      return new Promise(function (resolve, reject) {
        Vue.$geocoder.send(addressObj, response => {
          console.log(response);
          let result = {
            status: response.status,
            coords: null,
            metadata: null,
          };
          if (response.status == "OK" && response.results.length > 0) {
            //resolve(response.results[0].geometry.location);
            result.coords = response.results[0].geometry.location;
            result.metadata = response.results;
            resolve(result);
          } else {
            reject(result);
            //reject(response.status);
          }
        });
      });
    },

    // enableHighAccuracy will cause geolocation slow in iOS
    async getMyCoords() {
      const options = {
        //enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      };

      let myCoords;
      if (this.$store.getters.isNativeApp) {
        const { Geolocation } = Plugins;
        let myPosition = await Geolocation.getCurrentPosition(options);
        myCoords = {
          latitude: myPosition.coords.latitude,
          longitude: myPosition.coords.longitude,
        };
      } else {
        let myPosition = await this.$geolocation.getCurrentPosition(options);
        myCoords = myPosition.coords;
      }

      console.log("MyCoords", myCoords);
      return myCoords;
    },

    async getStoreDistance(myAddress) {
      console.log("getting store distance");
      console.log("myAddress", myAddress);

      let result = "ok";
      let message = "";
      let content = {
        myCoords: { lat: 0, lng: 0 },
        storeCoords: { lat: 0, lng: 0 },
        distanceBetween: 0,
      };

      try {
        let myCoords = null;
        let storeCoords = null;
        if (myAddress) {
          let getCoordsResult = await this.getCoords(myAddress);
          if (getCoordsResult.status == "OK") {
            myCoords = {
              latitude: getCoordsResult.coords.lat,
              longitude: getCoordsResult.coords.lng,
            };
          }
        } else {
          myCoords = await this.getMyCoords();
        }

        console.log("myCoords", myCoords);

        let store = this.$store.state.Store.store;
        if (myCoords) {
          let storeCoordsLat = null;
          let storeCoordsLng = null;
          if (store.coords) {
            storeCoordsLat = store.coords.lat;
            storeCoordsLng = store.coords.lng;
          }
          if (storeCoordsLat == null || storeCoordsLng == null) {
            if (this.storeAddressString != "") {
              let getCoordsResult = await this.getCoords(this.storeAddressString);
              if (getCoordsResult.status == "OK") {
                storeCoords = {
                  latitude: getCoordsResult.coords.lat,
                  longitude: getCoordsResult.coords.lng,
                };
              }
            }
          } else {
            storeCoords = {
              latitude: storeCoordsLat,
              longitude: storeCoordsLng,
            };
          }

          //console.log(store.coords);
          console.log("storeCoords", storeCoords);

          if (myCoords && storeCoords) {
            let distanceBetween = this.getDistance(myCoords, storeCoords);
            let distanceMatrix = await mRest.getDistanceMatrix(myCoords, storeCoords);

            content = {
              myCoords: { lat: myCoords.latitude, lng: myCoords.longitude },
              storeCoords: { lat: storeCoordsLat, lng: storeCoordsLng },
              distanceBetween: distanceBetween,
              distanceMatrix: distanceMatrix,
            };
            result = "ok";
          } else {
            result = "failed";
            message = "Location information is unavailable";
          }
        } else {
          result = "failed";
          message = "Location information is unavailable";
        }
      } catch (error) {
        console.log(error);

        result = "failed";
        message = this.getPositionErrorMessage(error);
      }

      let response = { result: result, message: message, content: content };
      console.log(response);
      return response;
    },

    async checkDistance(allowDistance, myAddress) {
      console.log("checkDistance/allowDistance=" + allowDistance);
      console.log("checkDistance/myAddress=" + myAddress);

      let res = {
        result: "ok",
        message: "",
        content: {
          myCoords: { lat: 0, lng: 0 },
          storeCoords: { lat: 0, lng: 0 },
          distanceBetween: 0,
        },
      };

      let n_res = await this.getStoreDistance(myAddress);
      if (n_res.result == "ok") {
        res.content = n_res.content;
      }
      if (allowDistance > 0) {
        if (n_res.result == "ok") {
          let distanceMeter = 0;
          if (
            res.content.distanceMatrix &&
            res.content.distanceMatrix.rows &&
            res.content.distanceMatrix.rows.length > 0
          ) {
            let row = res.content.distanceMatrix.rows[0];
            if (row.elements && row.elements.length > 0) {
              let ele = row.elements[0];
              console.log(ele);
              distanceMeter = ele.distance.value;
            }
          } else {
            distanceMeter = res.content.distanceBetween;
          }

          if (distanceMeter > allowDistance) {
            res.result = "failed";
            res.message = "You are far away from the store";
          }
        } else {
          res.result = "failed";
          res.message = n_res.message;
        }
      }

      console.log("checkDistance/result", res);
      return res;
    },

    async getDeliveryQuote(payload) {
      let dropOffAddress = payload?.dropoffAddress;
      let quote = {};

      if (this.$store.getters.doorDashEnabled) {
        let dropoffContact = payload?.dropoffContact;

        let pickupTime = new Date();
        pickupTime.setMinutes(pickupTime.getMinutes() + this.$store.getters.storeMealPrepMinutes);
        let res = await mRest.doorDashQuote({
          dropOffAddress: dropOffAddress,
          dropoffContact: dropoffContact,
          pickupTime: pickupTime,
        });

        if (res) {
          quote.result = res.result;
          if (res.result == "ok") {
            let pickupTime = mUtils.toDate(res.data.pickup_time_estimated);
            let deliveryTime = mUtils.toDate(res.data.dropoff_time_estimated);
            let deliveryDriveMin = Math.ceil((deliveryTime - pickupTime) / 60 / 1000);
            let deliveryValue = mUtils.roundNumber(res.data.fee / 100, 2);
            let deliveryTax = mUtils.roundNumber(res.data.tax / 100, 2);

            quote.doorDashDriveID = res.data.external_delivery_id;
            quote.address = dropOffAddress;
            quote.deliveryValue = deliveryValue;
            quote.deliveryWithhold = deliveryValue + deliveryTax;
            quote.deliveryTime = deliveryTime;
            quote.deliveryDriveMin = deliveryDriveMin;
          } else {
            quote.error = res.result;
            if (res.upstream_error_detail && Array.isArray(res.upstream_error_detail)) {
              res.upstream_error_detail.forEach(x => {
                if (x.error) quote.error += "<br>" + x.error;
              });
            } else if (res.upstream_error) quote.error = res.upstream_error;
          }
        } else {
          quote.result = "Unknown error";
          quote.error = res.result;
        }
      }

      if (!quote.error && (!this.$store.getters.doorDashEnabled || this.$store.getters.deliveryAgentChargeOverwrited)) {
        let deliveryAddressString = mUtils.addressToString(dropOffAddress);
        let res = await this.checkDistance(this.$store.getters.deliveryMaxDistance, deliveryAddressString);
        if (res.result == "ok") {
          let distanceMeter = 0;
          let deliveryValue = 0;
          let deliveryDriveMin = 0;
          if (
            res.content.distanceMatrix &&
            res.content.distanceMatrix.rows &&
            res.content.distanceMatrix.rows.length > 0
          ) {
            let row = res.content.distanceMatrix.rows[0];
            if (row.elements && row.elements.length > 0) {
              let ele = row.elements[0];
              distanceMeter = ele.distance.value;
              deliveryValue = this.$store.getters.deliveryCharge(distanceMeter);
              deliveryDriveMin = Math.ceil(ele.duration.value / 60);
            }
          } else {
            distanceMeter = res.content.distanceBetween;
            deliveryValue = this.$store.getters.deliveryCharge(distanceMeter);
            deliveryDriveMin = Math.ceil((distanceMeter / 1000) * 1.2);
          }

          if (!this.$store.getters.doorDashEnabled) {
            quote.result = res.result;
            quote.address = dropOffAddress;
            quote.deliveryDriveMin = deliveryDriveMin;
          }
          quote.deliveryValue = deliveryValue;

          quote.result = "ok";
        } else {
          quote.error = res.message;
        }
      }

      if (quote.result == "ok") {
        if (quote.deliveryWithhold == null) quote.deliveryWithhold = 0;
      }

      console.log("Delivery Quote", quote);
      return quote;
    },

    getPositionErrorMessage(positionError) {
      //"An unknown error occurred";
      let errorMessage = this.$t("position_error.unknown");
      if (positionError) {
        //"User denied the request for Geolocation";
        if (positionError.code == 1) errorMessage = this.$t("position_error.1");
        //"Location information is unavailable";
        else if (positionError.code == 2) errorMessage = this.$t("position_error.2");
        //"The request to get user location timed out";
        else if (positionError.code == 3) errorMessage = this.$t("position_error.3");
      }

      return errorMessage;
    },

    getStoreLocaleDate(store, date) {
      let localeDate = date;
      try {
        let storeUtcOffsetMin = store.info.timeZoneUtcOffsetMin;
        let localUtcOffsetMin = date.getTimezoneOffset();
        if (storeUtcOffsetMin !== undefined && storeUtcOffsetMin != -localUtcOffsetMin) {
          var today_utc = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
          let today_tz = new Date(today_utc.setMilliseconds(today_utc.getMilliseconds() + 60000 * storeUtcOffsetMin));
          localeDate = today_tz;
        }
      } catch (error) {
        console.log(error);
      }

      return localeDate;
    },

    getStoreTimeStatus(store) {
      let bhStatus = {
        now: new Date(),
        timeZoneAbbrev: "",
        opening: false,
        businessTimeLocaleString: "",
        businessTimeParams: {},
        preorderLocaleString: "",
      };

      let currentTime = new Date();
      let storeCurrentTime = this.getStoreLocaleDate(store, currentTime);
      if (currentTime != storeCurrentTime) {
        currentTime = storeCurrentTime;

        if (store.info.timeZoneAbbrev) {
          bhStatus.timeZoneAbbrev = store.info.timeZoneAbbrev;
        }
      }
      bhStatus.now = currentTime;

      if (!store.info?.businessHours) return bhStatus;

      let currentTimeString =
        currentTime
          .getHours()
          .toString()
          .padStart(2, "0") +
        ":" +
        currentTime
          .getMinutes()
          .toString()
          .padStart(2, "0");
      let dow = currentTime.getDay();
      let bHours = store.info.businessHours;
      let bDay = bHours[dow];
      let opening = false;

      if (bDay.off) {
        opening = false;
        bhStatus.businessTimeLocaleString = "business_time.closed_today";
        bhStatus.businessTimeParams = {};
        bhStatus.businessTimes = [];
      } else if (bDay.fullDay) {
        opening = true;
        bhStatus.businessTimeLocaleString = "business_time.open_24hr";
        bhStatus.businessTimeParams = {};
        bhStatus.businessTimes = [];
      } else {
        bhStatus.businessTimeParams = {};
        bhStatus.businessTimes = bDay.displayTimes;
        if (bDay.off) bhStatus.businessTimeLocaleString = "business_time.closed_today";
        else if (bDay.fullDay) bhStatus.businessTimeLocaleString = "business_time.open_24hr";
        else {
          opening = mUtils.timeInRanges(bDay.times, currentTimeString);

          let openTimes = mUtils.timesToString(bDay.displayTimes);
          bhStatus.businessTimeParams = { openTimes: openTimes };
          if (opening) bhStatus.businessTimeLocaleString = "business_time.open_now";
          else bhStatus.businessTimeLocaleString = "business_time.closed";
        }
      }
      bhStatus.opening = opening;

      let preorderLocaleString = "";
      if (!opening && store.info.takeoutHours && store.info.deliveryHours) {
        let takeoutDisabled = false;
        let deliveryDisabled = false;
        if (store) {
          if (store.orderType && store.orderType.takeout && store.orderType.takeout.hide === true)
            takeoutDisabled = store.orderType.takeout.hide;
          if (store.orderType && store.orderType.delivery && store.orderType.delivery.hide === true)
            deliveryDisabled = store.orderType.delivery.hide;
        }

        let acceptOrderForTakeout = false;
        let acceptOrderForDelivery = false;
        if (!takeoutDisabled && store.info.takeoutHours.length == 7) {
          let tHours = store.info.takeoutHours;
          let tDay = tHours[dow];
          acceptOrderForTakeout = mUtils.timeInRanges(tDay.times, currentTimeString);
        }
        if (!deliveryDisabled && store.info.deliveryHours.length == 7) {
          let dHours = store.info.deliveryHours;
          let dDay = dHours[dow];
          acceptOrderForDelivery = mUtils.timeInRanges(dDay.times, currentTimeString);
        }

        if (acceptOrderForTakeout && acceptOrderForDelivery) preorderLocaleString = "accept_preorder";
        else if (acceptOrderForTakeout) preorderLocaleString = "accept_preorder.takeout";
        else if (acceptOrderForDelivery) preorderLocaleString = "accept_preorder.delivery";
      }

      bhStatus.preorderLocaleString = preorderLocaleString;

      //console.log("getStoreTimeStatus", bhStatus)
      return bhStatus;
    },

    getVerifiedPhoneNumbers() {
      if (this.$idb == null) return null;
      let that = this;
      return new Promise(function (resolve) {
        let key = "VERIFIED_PHONE_NUMBERS";
        that.$idb.setting
          .get(key)
          .then(record => resolve(record.value))
          .catch(() => resolve(null));
      });
    },

    setVerifiedPhoneNumbers(phoneNumbers) {
      if (this.$idb == null) return false;
      let that = this;
      return new Promise(function (resolve) {
        let key = "VERIFIED_PHONE_NUMBERS";
        that.$idb.setting
          .put({ name: key, value: phoneNumbers })
          .then(() => {
            resolve(true);
          })
          .catch(error => {
            console.log("setVerifiedPhoneNumbers catched", error);
            resolve(false);
          });
      });
    },

    addVerifiedPhoneNumber(phoneNumber) {
      let that = this;
      return new Promise(function (resolve) {
        that
          .getVerifiedPhoneNumbers()
          .then(phoneNumbers => {
            if (!Array.isArray(phoneNumbers)) phoneNumbers = [];
            let index = phoneNumbers.indexOf(phoneNumber);
            if (index < 0) {
              phoneNumbers.unshift(phoneNumber);
              that
                .setVerifiedPhoneNumbers(phoneNumbers)
                .then(result => {
                  resolve(result);
                })
                .catch(error => {
                  console.log("addVerifiedPhoneNumber catched", error);
                  resolve(false);
                });
            } else {
              resolve(false);
            }
          })
          .catch(error => {
            console.log("addVerifiedPhoneNumber catched", error);
            return resolve(false);
          });
      });
    },

    isVerifiedPhoneNumber(phoneNumber) {
      let that = this;
      return new Promise(function (resolve) {
        if (that.$store.state.testMode && phoneNumber == "+1" + that.$store.state.testPhoneNo) {
          return resolve(true);
        } else {
          that
            .getVerifiedPhoneNumbers()
            .then(phones => {
              let index = phones == null ? -1 : phones.indexOf(phoneNumber);
              return resolve(index > -1);
            })
            .catch(error => {
              console.log("isVerifiedPhoneNumber catched", error);
              return resolve(false);
            });
        }
      });
    },

    //
    getVerifiedEmails() {
      if (this.$idb == null) return null;
      let that = this;
      return new Promise(function (resolve) {
        let key = "VERIFIED_EMAILS";
        that.$idb.setting
          .get(key)
          .then(record => resolve(record.value))
          .catch(() => resolve(null));
      });
    },

    setVerifiedEmails(emails) {
      if (this.$idb == null) return false;
      let that = this;
      return new Promise(function (resolve) {
        let key = "VERIFIED_EMAILS";
        that.$idb.setting
          .put({ name: key, value: emails })
          .then(() => {
            resolve(true);
          })
          .catch(error => {
            console.log("setVerifiedEmails catched", error);
            resolve(false);
          });
      });
    },

    addVerifiedEmail(email) {
      let that = this;
      return new Promise(function (resolve) {
        that
          .getVerifiedEmails()
          .then(emails => {
            if (!Array.isArray(emails)) emails = [];
            let index = emails.indexOf(email);
            if (index < 0) {
              emails.unshift(email);
              that
                .setVerifiedEmails(emails)
                .then(result => {
                  resolve(result);
                })
                .catch(error => {
                  console.log("addVerifiedEmail catched", error);
                  resolve(false);
                });
            } else {
              resolve(false);
            }
          })
          .catch(error => {
            console.log("addVerifiedEmail catched", error);
            return resolve(false);
          });
      });
    },

    isVerifiedEmail(email) {
      let that = this;
      return new Promise(function (resolve) {
        that
          .getVerifiedEmails()
          .then(emails => {
            let index = emails == null ? -1 : emails.indexOf(email);
            return resolve(index > -1);
          })
          .catch(error => {
            console.log("isVerifiedEmail catched", error);
            return resolve(false);
          });
      });
    },

    async confirmSwitchOrderType(orderType) {
      if (orderType == ORDER_TYPE.DINEIN && !this.$store.getters.storeDineinMenuMode) {
        if (this.$store.getters.storeDineinAskTableName) {
          let table = await mStore.askTableName();
          if (table) {
            this.$store.state.Order.order.tableID = table.ID;
            this.$store.state.Order.order.tableName = table.descr;
          } else return false;
        }
      } else {
        this.$store.state.Order.order.tableID = 0;
        this.$store.state.Order.order.tableName = "";
      }

      let switchOrderType = true;
      let om = this.$store.getters.storeOrderType(orderType);

      let o_priceLevel = this.$store.state.Order.order.priceLevel;
      let n_priceLevel = 0;
      if (om.priceLevel !== undefined && Number.isInteger(om.priceLevel)) n_priceLevel = om.priceLevel;

      if (this.$store.state.Order.order.orderItems.length > 0) {
        if (o_priceLevel != n_priceLevel) {
          switchOrderType = await mDialog.confirmDialog.open(
            this.$t("confirm_title_switch_ordertype") + this.$t(orderType) + "?",
            "",
            this.$t("confirm_leave_clear_cart"),
            { yesText: this.$t("confirm_button_switch") }
          );
        } else {
          if (orderType == ORDER_TYPE.DINEIN) {
            let promoOi = this.$store.state.Order.order.orderItems.find(x => x.promo);
            if (promoOi) {
              switchOrderType = await mDialog.confirmDialog.open(
                this.$t("confirm_title_switch_ordertype") + this.$t(orderType) + "?",
                "",
                this.$t("confirm_leave_remove_promo_cart"),
                { yesText: this.$t("confirm_button_switch") }
              );
            }
          }
        }
      }
      return switchOrderType;
    },

    moveAddressToFirst(address) {
      if (this.$store.state.addressList === undefined) return;

      this.$store.state.addressList = this.$store.state.addressList.filter(a => a !== address);
      this.$store.state.addressList.unshift(address);
    },

    setLanguage(language) {
      //console.log("language", language);

      this.$store.state.languageSelected = language;
      this.$i18n.locale = language.locale;

      this.$store.state.descrIndex = 0;
      if (this.$store.state.languageSelected && this.$store.state.languageSelected.descrIndex) {
        this.$store.state.descrIndex = this.$store.state.languageSelected.descrIndex;
      }

      if (this.$appMode == APP_MODE.APP || this.$appMode == APP_MODE.KIOSK) {
        this.setLanguageIdToStorage(language.id);
      }
    },

    getLanguageIdFromStorage() {
      let id = 0;
      let key = "LNG_" + this.$store.getters.storageKey;
      if (localStorage.getItem(key)) {
        id = localStorage.getItem(key);
      }
      return id;
    },

    setLanguageIdToStorage(id) {
      let key = "LNG_" + this.$store.getters.storageKey;
      localStorage.setItem(key, id);
    },

    async loadOrderHistory() {
      let orderHistory = [];
      if (this.$store.getters.orderHistoryOnCloud) {
        let resp = await mOrder.getOrders();
        if (resp.result == "ok") {
          resp.orders.forEach(o => {
            let ele = { feed: o, referenceID: o.referenceID, time: o.checkoutTimeTz };
            orderHistory.push(ele);
          });
        }
      }

      let localOrderHistory = this.getOrderHistory();
      localOrderHistory.forEach(ele => {
        let foundEle = orderHistory.find(x => x.feed.orderUUID == ele.feed.orderUUID);
        if (foundEle == null) {
          orderHistory.push(ele);
        }
      });

      orderHistory.sort(function (a, b) {
        if (a.time > b.time) return -1;
        else if (b.time > a.time) return 1;
        else return 0;
      });

      this.$store.state.orderHistory = orderHistory;

      //console.log("orderHistory", this.$store.state.orderHistory);
    },

    getOrderHistory() {
      let orderHistory = [];
      let key = "OHX_" + this.$store.getters.storeCompanyCode;
      if (localStorage.getItem(key)) {
        orderHistory = JSON.parse(localStorage.getItem(key));
        orderHistory.forEach(element => {
          if (element.order && element.feed == null) {
            let feed = mOrder.orderToFeed(element.order);
            this.$set(element, "feed", feed);
          }
        });
      }

      return orderHistory;
    },

    // add guest order to local history
    addOrderHistory(referenceID) {
      if (this.$store.getters.memberCode != "") return;

      try {
        let orderHistory = this.getOrderHistory();
        if (orderHistory.length >= 20) orderHistory.pop();

        let key = "OHX_" + this.$store.getters.storeCompanyCode;
        let ord = {
          time: new Date().toISOString(),
          referenceID: referenceID,
          order: this.$store.state.Order.order,
          feed: mOrder.orderToFeed(this.$store.state.Order.order),
        };
        orderHistory.unshift(ord);
        localStorage.setItem(key, JSON.stringify(orderHistory));
      } catch (error) {
        console.log(error);
      }
    },

    // set history to local storage
    setOrderHistory(orders) {
      let key = "OHX_" + this.$store.getters.storeCompanyCode;
      localStorage.setItem(key, JSON.stringify(orders));
    },

    // clear history from local storage
    clearOrderHistory() {
      try {
        let key = "OHX_" + this.$store.getters.storeCompanyCode;
        this.$store.state.orderHistory = [];
        localStorage.setItem(key, JSON.stringify(this.$store.state.orderHistory));
      } catch (error) {
        console.log(error);
      }
    },

    loadAddressList() {
      this.$store.state.addressList = [];

      let key = "ADR_" + this.$store.getters.storageKey;
      if (localStorage.getItem(key)) {
        this.$store.state.addressList = JSON.parse(localStorage.getItem(key));
      }
    },

    saveAddressList(addressList) {
      if (addressList === undefined) {
        addressList = this.$store.state.addressList;
      }
      let key = "ADR_" + this.$store.getters.storageKey;
      localStorage.setItem(key, JSON.stringify(addressList));
    },

    updateNewsFeeds() {
      let that = this;
      return new Promise(resolve => {
        if (that.$store.state.Menu.menuDisabled) {
          this.$store.commit("newsFeeds", []);
          resolve(true);
        } else {
          mRest.getNewsFeed().then(resp => {
            if (resp && resp.result == "ok") {
              let newsFeeds = resp.record;
              newsFeeds.forEach(nf => {
                let title = nf.Titles.def;
                let title1 = title;
                let title2 = title;
                let content = nf.Contents.def;
                let content1 = content;
                let content2 = content;

                that.$store.getters.languages.forEach(lang => {
                  let nfLangTitle = nf.Titles[lang.locale];
                  if (nfLangTitle) {
                    if (lang.descrIndex == 0) title = nfLangTitle;
                    else if (lang.descrIndex == 1) title1 = nfLangTitle;
                    else if (lang.descrIndex == 2) title2 = nfLangTitle;
                  }

                  let nfLangContent = nf.Contents[lang.locale];
                  if (nfLangContent) {
                    if (lang.descrIndex == 0) content = nfLangContent;
                    else if (lang.descrIndex == 1) content1 = nfLangContent;
                    else if (lang.descrIndex == 2) content2 = nfLangContent;
                  }
                });

                that.$set(nf, "title", title);
                that.$set(nf, "title1", title1);
                that.$set(nf, "title2", title2);
                that.$set(nf, "content", content);
                that.$set(nf, "content1", content1);
                that.$set(nf, "content2", content2);
              });

              this.$store.commit("newsFeeds", newsFeeds);
            } else {
              this.$store.commit("newsFeeds", []);
            }

            resolve(true);
          });
        }
      });
    },

    async validatePromo(promo) {
      if (!this.$store.getters.acceptOrder) {
        mOrder.showNotAcceptOrderDialog();
        return false;
      }

      if (promo.ValidFrom) {
        let validFrom = mUtils.toDate(promo.ValidFrom);
        console.log(validFrom);
        let today = new Date();
        console.log(today);
        if (validFrom > today) {
          mDialog.messageDialog.open(
            this.$t("error_alert_title"),
            "",
            this.$t("promo_valid_from", {
              valid_from: validFrom.toLocaleDateString(),
            })
          );
          return false;
        }
      }

      let allowMultiPromo = false;
      if (allowMultiPromo) {
        if (promo.TargetType == "subtotal") {
          let promoSubOi = this.$store.state.Order.order.orderItems.find(
            oi => oi.promo && oi.promo.TargetType == "subtotal"
          );
          if (promoSubOi) {
            mDialog.messageDialog.open(this.$t("error_alert_title"), "", this.$t("promo_one_an_order"));
            return false;
          }
        }
      } else {
        let promoOi = this.$store.state.Order.order.orderItems.find(oi => oi.promo);
        if (promoOi) {
          mDialog.messageDialog.open(this.$t("error_alert_title"), "", this.$t("promo_one_an_order"));
          return false;
        }
      }

      if (!this.$store.state.member) {
        let logined =
          mDialog.memberLoginDialog &&
          (await mDialog.memberLoginDialog.open({ message: this.$t("login.to_claim_coupon") }));
        if (logined) {
          let memberCode = this.$store.state.member.MemberCode;
          let promos = await mMember.getMemberPromos(memberCode);
          if (promos.length > 0) {
            let _promo = promos.find(p => p.PromoteCode == promo.PromoteCode);
            if (_promo == null) {
              mDialog.messageDialog.open(
                this.$t("error_alert_title"),
                "",
                this.$t("error_promo_redeemed", { promo: promo.Title })
              );
              return false;
            }
          } else {
            mDialog.messageDialog.open(this.$t("error_alert_title"), "", this.$t("error_promo_get"));
            return false;
          }
        } else {
          return false;
        }
      }

      return true;
    },

    async addPromoToCart(promo) {
      console.log("addPromoToCart.promo", promo);

      let customData = promo.CustomData;

      let item = {
        ID: 0,
        descr: promo.title,
        descr1: promo.title1,
        descr2: promo.title2,
        detail: promo.detail,
        detail1: promo.detail1,
        detail2: promo.detail2,
        price: 0,
        gst: customData.Gst == undefined || customData.Gst === true ? true : false,
        pst: customData.Pst == undefined || customData.Pst === true ? true : false,
        liq: customData.Liq === true ? true : false,
        bItems: null,
        itemDiscountable: false,
        itemDiscountRate: 0,
        itemDiscountValue: 0,
        discountable: true,
        promo: promo,
      };

      if (customData.BillDiscountable) item.discountable = customData.BillDiscountable;

      let buyQty = 1;
      if (promo.BuyRatio && typeof promo.BuyRatio == "number") buyQty = promo.BuyRatio;
      if (buyQty <= 0) buyQty = 1;
      let buySingle = customData.BuySingle == null ? false : customData.BuySingle;

      let getQty = 1;
      if (promo.GetRatio && typeof promo.GetRatio == "number") getQty = promo.GetRatio;
      if (getQty <= 0) getQty = 1;
      let getSingle = customData.GetSingle == null ? false : customData.GetSingle;

      let buyDiscountRate = 0;
      let buyDiscountValue = 0;
      let getDiscountRate = 0;
      let getDiscountValue = 0;
      if (promo.TargetType == "item") {
        if (promo.DiscValue && typeof promo.DiscValue == "number") {
          if (promo.DiscByPercentage === true) getDiscountRate = promo.DiscValue;
          else getDiscountValue = promo.DiscValue;
        }
        if (customData.GetProducts == null && customData.GetGroups == null) {
          buyDiscountRate = getDiscountRate;
          buyDiscountValue = getDiscountValue;
        }
      }

      item.bItems = [];

      if (customData.BuyProducts) {
        let bItem = null;
        let itemCodes;
        if (customData.BuyProducts.length == 1) {
          let barcode = customData.BuyProducts[0];
          bItem = this.$store.state.Menu.items.find(i => i.barcode != "" && i.barcode == barcode);
        } else {
          itemCodes = customData.BuyProducts;
          bItem = {
            ID: 0,
            descr: "?",
            descr1: "?",
            descr2: "?",
            price: 0,
            gst: true,
            pst: true,
            liq: false,
            itemDiscountable: true,
            billDiscountable: true,
          };
        }
        if (bItem) {
          let loopCount;
          let qty;

          if (buySingle) {
            loopCount = 1;
            qty = buyQty;
          } else {
            loopCount = buyQty;
            qty = 1;
          }

          for (let ii = 0; ii < loopCount; ii++) {
            let bi = {
              applyDiff: "all",
              itemCodes: itemCodes,
              qty: qty,
              itemDiscountRate: buyDiscountRate,
              itemDiscountValue: buyDiscountValue,
              item: bItem,
            };
            item.bItems.push(bi);
          }
        }
      } else if (customData.BuyGroups && customData.BuyGroups.length > 0) {
        let loopCount;
        let qty;

        if (buySingle) {
          loopCount = 1;
          qty = buyQty;
        } else {
          loopCount = buyQty;
          qty = 1;
        }

        for (let ii = 0; ii < loopCount; ii++) {
          let bi = {
            applyDiff: "all",
            catCodes: customData.BuyGroups,
            qty: qty,
            itemDiscountRate: buyDiscountRate,
            itemDiscountValue: buyDiscountValue,
            item: {
              ID: 0,
              descr: "?",
              descr1: "?",
              descr2: "?",
              price: 0,
              gst: true,
              pst: true,
              liq: false,
              itemDiscountable: true,
              billDiscountable: true,
            },
          };
          item.bItems.push(bi);
        }
      }

      if (customData.GetProducts && customData.GetProducts.length > 0) {
        let bItem = null;
        let itemCodes;
        if (customData.GetProducts.length == 1) {
          let barcode = customData.GetProducts[0];
          bItem = this.$store.state.Menu.items.find(i => i.barcode != "" && i.barcode == barcode);
          if (!bItem) {
            let resp = await mRest.getItems({ barcode: barcode });
            if (resp && resp.result == "ok" && resp.items.length > 0) {
              bItem = resp.items[0];
            }
          }
        } else {
          itemCodes = customData.GetProducts;
          bItem = {
            ID: 0,
            descr: "?",
            descr1: "?",
            descr2: "?",
            price: 0,
            gst: true,
            pst: true,
            liq: false,
            itemDiscountable: true,
            billDiscountable: true,
          };
        }

        if (bItem) {
          let loopCount;
          let qty;

          if (getSingle) {
            loopCount = 1;
            qty = getQty;
          } else {
            loopCount = getQty;
            qty = 1;
          }

          for (let ii = 0; ii < loopCount; ii++) {
            let bi = {
              applyDiff: "all",
              itemCodes: itemCodes,
              qty: qty,
              itemDiscountRate: getDiscountRate,
              itemDiscountValue: getDiscountValue,
              item: bItem,
            };
            item.bItems.push(bi);
          }
        }
      } else if (customData.GetGroups && customData.GetGroups.length > 0) {
        let loopCount;
        let qty;
        if (getQty > 0) {
          if (getSingle) {
            loopCount = 1;
            qty = getQty;
          } else {
            loopCount = getQty;
            qty = 1;
          }
        }

        for (let ii = 0; ii < loopCount; ii++) {
          let bi = {
            applyDiff: "all",
            catCodes: customData.GetGroups,
            qty: qty,
            itemDiscountRate: getDiscountRate,
            itemDiscountValue: getDiscountValue,
            item: {
              ID: 0,
              descr: "?",
              descr1: "?",
              descr2: "?",
              price: 0,
              gst: true,
              pst: true,
              liq: false,
              itemDiscountable: true,
              billDiscountable: true,
            },
          };
          item.bItems.push(bi);
        }
      }

      console.log("addPromoToCart.item", item);

      if (item.bItems.length > 0) {
        let params = { item: item };
        mApp.navName("OrderBundle", params);
      } else {
        let oi = this.itemToOrderItem(item);
        mOrder.addOrderItem(oi);
      }
    },

    async setStore(store) {
      this.$store.commit("store", store);
      if (store?.info) {
        let storeCoordsLat = null;
        let storeCoordsLng = null;
        if (store.coords) {
          storeCoordsLat = store.coords.lat;
          storeCoordsLng = store.coords.lng;
        }

        if (storeCoordsLat == null || storeCoordsLng == null) {
          if (this.storeAddressString != "") {
            let getCoordsResult = await this.getCoords(this.storeAddressString);
            this.storeCoords = getCoordsResult.coords;
          }
        } else {
          this.storeCoords = store.coords;
        }

        if (!isNaN(store.info.orderServerBuildNo)) this.$store.state.serverBuildNo = store.info.orderServerBuildNo;
      }
    },

    refreshStores(getMyPosition) {
      this.$store.state.Store.stores.list.forEach(store => {
        try {
          let timeStatus = this.getStoreTimeStatus(store);
          this.$set(store, "timeStatus", timeStatus);
        } catch (error) {
          console.log(error);
        }
      });

      let currentTime = new Date();
      if (getMyPosition == null)
        getMyPosition =
          this.positionGetTime == null || (currentTime.getTime() - this.positionGetTime.getTime()) / 1000 / 60 > 1;

      if (getMyPosition) {
        this.getMyCoords()
          .then(myCoords => {
            this.positionGetTime = new Date();

            this.$store.state.myCoords = myCoords;
            if (this.$store.state.myCoords) {
              this.$store.state.Store.stores.list.forEach(store => {
                if (store.coords) {
                  let storeCoords = {
                    latitude: store.coords.lat,
                    longitude: store.coords.lng,
                  };

                  let distance = this.getDistance(myCoords, storeCoords);
                  //console.log(distance);
                  this.$set(store, "distanceBetween", distance);
                }
              });

              this.sortStores();
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },

    sortStores() {
      this.$store.state.Store.stores.list.sort(
        (a, b) =>
          (a.distanceBetween == null ? 0 : a.distanceBetween) - (b.distanceBetween == null ? 0 : b.distanceBetween)
      );
    },

    async storeSelected(store, params) {
      if (store.info?.fullInfo === false) {
        let resp = await mStore.getStore(store.sessionKey);
        if (resp && resp.result == "ok") {
          store = Object.assign(store, resp.store);
        } else return false;
      }

      let ok = true;

      this.$store.state.serverBuildNo = 0;
      this.setStore(store);

      if (this.$store.state.serverBuildNo == 0 && this.$store.state.appData.type == "order") {
        let res_status = await mRest.getServerStatus();
        if (res_status?.buildNo > 0) this.$store.state.serverBuildNo = res_status.buildNo;
        else return false;
      }

      this.$store.commit("rootCatIDs", []);
      if (params) {
        //if (params.catID > 0) this.$store.commit("rootCatID", params.catID);
        if (Array.isArray(params.catIDs) && params.catIDs.length > 0) this.$store.commit("rootCatIDs", params.catIDs.map(String));
        if (params.storeHome) this.$set(store.config, "storeHome", params.storeHome);
      }

      // init config
      this.$store.state.Order.ordDidCount = 1;
      this.$store.state.sideComboTags = [];

      this.$store.commit("menu", []);
      this.$store.commit("items", []);

      this.$store.commit("menuClassify", 0);

      mApp.setLaunchTime();

      mOrder.initOrder();

      let paramTableID = 0;
      let paramOrderType = "";
      if (params) {
        if (params.tableID) paramTableID = params.tableID;
        if (params.orderType) paramOrderType = params.orderType;

        if (paramOrderType == ORDER_TYPE.TAKEOUT || paramOrderType == ORDER_TYPE.DELIVERY) paramTableID = 0;
      }
      this.$store.state.Order.order.tableID = 0;
      this.$store.state.Order.order.tableName = "";
      if (paramTableID > 0) {
        let res_table = await mRest.getTable({ tableID: paramTableID });
        if (res_table.result == "ok") {
          let tables = res_table.tables;
          if (tables.length > 0) {
            let table = tables[0];

            this.$store.state.Order.order.orderType = ORDER_TYPE.DINEIN;
            this.$store.state.Order.order.tableID = table.ID;
            this.$store.state.Order.order.tableName = table.descr;

            await mOrder.setOrderType(ORDER_TYPE.DINEIN);
          } else return false;
        } else return false;
      } else if (paramOrderType) {
        if (
          params.orderType == ORDER_TYPE.DINEIN ||
          params.orderType == ORDER_TYPE.TAKEOUT ||
          params.orderType == ORDER_TYPE.DELIVERY
        ) {
          this.$store.state.Order.order.orderType = paramOrderType;
          await mOrder.setOrderType(paramOrderType);
        }
      }

      if (this.$appMode == APP_MODE.APP || this.$appMode == APP_MODE.KIOSK) {
        mOrder.updateOrderMember();
      } else {
        if (this.$store.getters.memberEnabled) {
          let lastLogin = await this.getLastLogin();
          if (lastLogin) {
            if (lastLogin.isMember) {
              let getParams;
              if (lastLogin.phone1 != "") {
                let phoneId = "+1" + lastLogin.phone1.replace(/\D+/g, "");
                let isVerifiedPhoneNumber = await this.isVerifiedPhoneNumber(phoneId);
                if (isVerifiedPhoneNumber) {
                  getParams = { phoneId: phoneId };
                }
              } else if (lastLogin.memberCode != "") {
                getParams = { memberCode: lastLogin.memberCode };
              }
              if (getParams) {
                await mMember.getMember(getParams);
              }
            }
          }
        }

        if (this.$store.state.member) {
          mMember.getGiftcards();
        } else {
          this.$store.commit("giftcards", []);
        }

        mMember.updateMemberPromos(this.$store.getters.memberCode);
        this.updateNewsFeeds();

        mOrder.updateOrderMember();

        this.loadAddressList();

        // language
        let curLanguage;
        let storeInfo = this.$store.getters.storeInfo;
        if (storeInfo && storeInfo.languages && storeInfo.languages.length > 0) {
          let languageIndex = 0;
          let storeConfig = this.$store.getters.storeConfig;
          if (storeConfig) {
            if (
              storeConfig.languageIndex &&
              typeof storeConfig.languageIndex == "number" &&
              storeInfo.languages.length > storeConfig.languageIndex
            ) {
              languageIndex = storeConfig.languageIndex;
            }
          }

          let lang = storeInfo.languages[languageIndex];
          if (store.messages) {
            let storeMessage = store.messages;

            storeInfo.languages.forEach(lang => {
              let homeMessage = storeMessage.home ? storeMessage.home[lang.locale] : "";
              this.$i18n.mergeLocaleMessage(lang.locale, {
                "home-message": homeMessage,
              });
              let dineinMessage = storeMessage.dinein ? storeMessage.dinein[lang.locale] : "";
              this.$i18n.mergeLocaleMessage(lang.locale, {
                "dinein-message": dineinMessage,
              });
              let takeoutMessage = storeMessage.takeout ? storeMessage.takeout[lang.locale] : "";
              this.$i18n.mergeLocaleMessage(lang.locale, {
                "takeout-message": takeoutMessage,
              });
              let deliveryMessage = storeMessage.delivery ? storeMessage.delivery[lang.locale] : "";
              this.$i18n.mergeLocaleMessage(lang.locale, {
                "delivery-message": deliveryMessage,
              });
              let checkoutMessage = storeMessage.checkout ? storeMessage.checkout[lang.locale] : "";
              this.$i18n.mergeLocaleMessage(lang.locale, {
                "checkout-message": checkoutMessage,
              });
            });
          } else {
            this.$i18n.mergeLocaleMessage(lang.locale, { "home-message": "" });
            this.$i18n.mergeLocaleMessage(lang.locale, {
              "dinein-message": "",
            });
            this.$i18n.mergeLocaleMessage(lang.locale, {
              "takeout-message": "",
            });
            this.$i18n.mergeLocaleMessage(lang.locale, {
              "delivery-message": "",
            });
            this.$i18n.mergeLocaleMessage(lang.locale, {
              "checkout-message": "",
            });
          }

          let giftcardLabels = store.service?.giftcardLabel;
          if (!giftcardLabels) giftcardLabels = {};
          storeInfo.languages.forEach(lang => {
            let label = (label = giftcardLabels[lang.locale]);
            if (!label) label = giftcardLabels["def"];
            if (!label) label = this.$i18n.messages[lang.locale]._giftcard;
            this.$i18n.mergeLocaleMessage(lang.locale, {
              giftcard: label,
            });
          });

          curLanguage = lang;
        } else {
          this.$i18n.locale = "en";
          this.$i18n.mergeLocaleMessage(this.$i18n.locale, {
            "home-message": "",
          });
          this.$i18n.mergeLocaleMessage(this.$i18n.locale, {
            "dinein-message": "",
          });
          this.$i18n.mergeLocaleMessage(this.$i18n.locale, {
            "takeout-message": "",
          });
          this.$i18n.mergeLocaleMessage(this.$i18n.locale, {
            "delivery-message": "",
          });
        }
        this.$store.state.descrIndex = 0;
        this.$store.state.languageSelected = null;
        if (curLanguage) this.setLanguage(curLanguage);

        // theme
        if (store.theme) this.setTheme(store.theme);
      }

      return ok;
    },

    reloadMember() {
      if (this.$store.state.member == null || this.$store.getters.memberCode == "") return;

      mMember.getMember({ memberCode: this.$store.getters.memberCode });
    },

    searchMenuItem() {
      let params = { mode: "search" };
      mApp.navName("MenuItem", params);
    },

    searchRedeemItem() {
      let params = { mode: "search" };
      mApp.navName("MenuItem", params);
    },

    itemToOrderItem(item) {
      let oi = {
        ID: 0,
        key: undefined,
        descr: "",
        descr1: "",
        descr2: "",
        barcode: "",
        groupID: "",
        remark: "",
        options: [],
        price: 0,
        qty: 1,
        optionValue: 0,
        extended: 0,
        gst: false,
        pst: false,
        liq: false,
        bItem: false,
        bundleItems: [],
        bundleChangeFees: 0,
        bAdj: 0,
        combos: [],
        combo: {},
        tag: "",
        cbRefID: 0,
        redeemItem: false,
        redeemPoints: 0,
        detail: "",
        detail1: "",
        detail2: "",
        itemDiscountable: true,
        billDiscountable: true,
        optionDiscountable: true,
        itemDiscountRate: 0,
        itemDiscountValue: 0,
        replaceDescrWithOption: false,
        o_price: 0,
        o_optionValue: 0,
        ord_descr: "",
        ord_descr1: "",
        ord_descr2: "",
        ord_did: 0,
        ord_time: Date.now(),
        item: null,
        promo: null,
      };

      oi.item = mUtils.cloneObject(item);
      oi.promo = item.promo;
      oi.ID = item.ID;
      oi.key = item.key;
      oi.descr = item.descr;
      oi.descr1 = item.descr1;
      oi.descr2 = item.descr2;
      oi.barcode = item.barcode;
      oi.detail = item.detail;
      oi.detail1 = item.detail1;
      oi.detail2 = item.detail2;
      oi.billDiscountable = item.discountable == null ? true : item.discountable;
      oi.itemDiscountable = item.itemDiscountable == null ? true : item.itemDiscountable;
      oi.optionDiscountable = item.optionDiscountable == null ? true : item.optionDiscountable;
      oi.itemDiscountRate = item.itemDiscountRate == null ? 0 : item.itemDiscountRate;
      oi.itemDiscountValue = item.itemDiscountValue == null ? 0 : item.itemDiscountValue;
      oi.redeemItem = item.redeemItem === true;
      oi.redeemPoints = item.redeemPoints;
      oi.price = oi.redeemItem ? 0 : this.$store.getters.itemPrice(item);
      oi.o_price = this.$store.getters.itemPrice(item);
      oi.gst = item.gst;
      oi.pst = item.pst;
      oi.liq = item.liq;
      oi.bItem = item.bItem;
      oi.combos = oi.redeemItem ? undefined : item.combos;
      oi.tag = oi.redeemItem ? "" : item.tag;

      oi.options = [];
      if (oi.item.options)
        for (let cg of oi.item.options) {
          if (!("ordered" in cg)) {
            cg.ordered = Array();
          }
          let cg_items = [];
          cg.qty = 0;
          for (let cg_item of cg.items) {
            if (cg_item.descr != "") {
              let itemOptionPrice = this.$store.getters.itemOptionPrice(cg_item);

              cg_items.push(cg_item);
              cg_item.price = oi.redeemItem && cg_item.redeemable ? 0 : itemOptionPrice;
              cg_item.o_price = itemOptionPrice;

              if (oi.redeemItem && cg_item.redeemable && cg_item.redeemPoints > 0 && cg_item.chodef)
                oi.redeemPoints += cg_item.redeemPoints;

              cg_item.toggle = false;
              cg_item.qty = 0;
            }
          }

          if (cg_items.length > 0) {
            cg.items = cg_items;
            oi.options.push(cg);
          }
        }

      mOrder.updateOptionsValue(oi);
      oi.replaceDescrWithOption = oi.descr.substring(0, 1) == "*";
      oi.ord_did = this.$store.state.Order.ordDidCount++;
      oi.ord_descr = this.getOrderText(oi, 0);
      oi.ord_descr1 = this.getOrderText(oi, 1);
      oi.ord_descr2 = this.getOrderText(oi, 2);

      if (oi.item.bItems && oi.item.bItems.length > 0 && this.$store.state.serverBuildNo >= 143) {
        oi.bundleChangeFees = item.bundleChangeFees;
        oi.item.bItems.forEach(bi => {
          let n_bi = {
            bItem: true,

            applyDiff: bi.applyDiff,
            itemPrice: oi.promo == null ? this.$store.getters.itemPrice(bi.item) /*bi.item.price*/ : 0,
            catIDs: bi.defCatID ? [bi.defCatID] : bi.catIDs,
            catCodes: bi.catCodes,
            itemCodes: bi.itemCodes,
            itemDiscountRate: bi.itemDiscountRate,
            itemDiscountValue: bi.itemDiscountValue,
            qty: bi.qty ? bi.qty : 1,

            replaceWithNewItem: bi.item.descr.substring(0, 1) == "?",
            orderItem: {},
            accepted: false,
            bundleItemPrice: 0,
          };
          bi.item.itemDiscountRate = bi.itemDiscountRate;
          bi.item.itemDiscountValue = bi.itemDiscountValue;

          let n_boi = this.itemToOrderItem(bi.item);
          n_bi.orderItem = n_boi;
          n_bi.orderItem.qty = n_bi.qty;
          oi.bundleItems.push(n_bi);
        });
      }

      return oi;
    },

    getOrderText(oi, descrIndex) {
      let itemText = "";
      if (descrIndex == 1 && oi.descr1 && oi.descr1 != "") itemText = oi.descr1;
      else if (descrIndex == 2 && oi.descr2 && oi.descr2 != "") itemText = oi.descr2;
      else itemText = oi.descr;
      let optText = this.getOptionsText(oi, descrIndex);

      let result = "";
      if (oi.replaceDescrWithOption) {
        if (optText == "") {
          result = itemText;
          if (result.substring(0, 1) == "*" && result.length >= 2) {
            result = result.substring(1);
          }
        } else result = optText;
      } else if (itemText.substring(0, 1) == "?") {
        if (itemText.length >= 2) itemText = itemText.substring(1);
        else {
          let lang = this.$store.getters.languages.find(language => language.descrIndex == descrIndex);
          if (lang) {
            itemText = this.$t("pick_your_own", lang.locale);
          }
        }
        result = itemText + optText;
      } else {
        result = itemText + optText;
      }
      return result;
    },

    getOptionsText(oi, descrIndex) {
      let result = "";
      let lastHeaderName = "";
      for (let og of oi.options) {
        let prefix = " ";
        let delimiter = " ";
        let headerName = "";
        if (og.printHeaderName) {
          if (descrIndex == 1 && og.name1 != "") headerName = og.name1;
          else if (descrIndex == 2 && og.name2 != "") headerName = og.name2;
          else headerName = og.name;

          if (headerName != "") headerName = "\n" + headerName + " : ";

          lastHeaderName = headerName;
        }
        if (og.prefix) prefix = og.prefix;
        if (og.delimiter) delimiter = og.delimiter;

        if (headerName == "" && lastHeaderName != "") prefix = "\n";
        else if (prefix == "space" || prefix == "enter") prefix = " ";
        else if (prefix == "empty") prefix = "";

        if (delimiter == "space" || delimiter == "enter") delimiter = " ";
        else if (delimiter == "empty") delimiter = "";

        let optInGrp = "";
        for (let opt of og.items) {
          let optDescr = "";
          if (descrIndex == 1 && opt.descr1 != "") optDescr = opt.descr1;
          else if (descrIndex == 2 && opt.descr2 != "") optDescr = opt.descr2;
          else optDescr = opt.descr;

          if (opt.qty > 0)
            optInGrp += (optInGrp == "" ? "" : delimiter) + (opt.qty == 1 ? optDescr : opt.qty + "x" + optDescr);
        }
        if (optInGrp != "") {
          result += headerName + prefix + optInGrp;
        }
      }
      return result;
    },

    // not run if it has been less than 5 seconds since the last update
    async updateItemInventory(item) {
      if (item) {
        let inventoryLastUpdated = item.inventoryLastUpdated;
        if (inventoryLastUpdated === undefined || isNaN(inventoryLastUpdated)) inventoryLastUpdated = 0;
        //if (Date.now() - inventoryLastUpdated < 5000) return;

        let response = await mRest.getItemInventory([item.ID]);
        if (response.result == "ok" && response.items.length == 1) {
          let inventory = response.items[0];
          item.soldout = inventory.soldout;
          item.ohQty = inventory.qty;
          item.inventoryLastUpdated = Date.now();

          if (item.options && inventory.options && inventory.options.length > 0) {
            item.options.forEach(optc => {
              if (optc.items) {
                optc.items.forEach(opti => {
                  let inventoryOpt = inventory.options.find(o => o.ID == opti.ID);
                  if (inventoryOpt) {
                    this.$set(opti, "countable", inventoryOpt.countable);
                    this.$set(opti, "ohQty", inventoryOpt.qty);
                    this.$set(opti, "soldout", inventoryOpt.soldout);
                  }
                });
              }
            });
          }
        }
      }
    },

    async checkItemOrderable(item, params) {
      console.log("checkItemOrderable", item, params);

      let showMessage = params == null || params.showMessage == null ? true : params.showMessage;
      let showMessageIfSoldout =
        params == null || params.showMessageIfSoldout == null ? false : params.showMessageIfSoldout;

      if (item == null) return false;
      if (item.orderDisabled || item.disabled) return false;

      // false if store not accept order
      if (!this.$store.getters.acceptOrder) {
        await mStore.getStoreHours();
      }

      if (!this.$store.getters.acceptOrder) {
        if (showMessage) {
          mOrder.showNotAcceptOrderDialog();
        }
        return false;
      }

      // false if not enought point to redeem
      if (this.$store.getters.itemNotEnoughPoint(item)) {
        if (showMessage) {
          mDialog.messageDialog.open(this.$t("redeem"), "", this.$t("error_not_enough_point_redeem"));
        }

        return false;
      }

      // false if item soldout
      let o_soldout = this.$store.getters.itemSoldout(item);
      await this.updateItemInventory(item);
      let n_soldout = this.$store.getters.itemSoldout(item);

      if (n_soldout && showMessageIfSoldout) {
        mDialog.messageDialog.open(this.$store.getters.itemDescr(item), "", this.$t("MENU.out_of_stock"));
        return false;
      }

      if (o_soldout) {
        if (!n_soldout && showMessage) {
          mDialog.messageDialog.open(this.$store.getters.itemDescr(item), "", this.$t("MENU.in_stock"));
        }
      } else {
        if (n_soldout && showMessage) {
          mDialog.messageDialog.open(this.$store.getters.itemDescr(item), "", this.$t("MENU.out_of_stock"));
        }
      }
      if (n_soldout) return false;

      return true;
    },

    openCheckoutExpiryDialog() {
      mDialog.checkoutExpiryDialog.open();
    },

    startCheckoutExpiryTimer(allocatingItems, timeoutFunction) {
      this.clearCheckoutExpiryTimer();

      console.log("Start Checkout Expiry Timer");
      // 15 minutes - 20 seconds
      let timeoutMSec = 20 * 60 * 1000 - 20 * 1000;
      if (this.$devEnv) timeoutMSec = 1 * 60 * 1000 - 20 * 1000;
      this.$store.state.checkoutExpiryTimeout = setTimeout(() => {
        mDialog.checkoutExpiryDialog.open(allocatingItems, timeoutFunction);
      }, timeoutMSec);
    },

    clearCheckoutExpiryTimer() {
      console.log("Clear Checkout Expiry Timer");
      if (this.$store.state.checkoutExpiryTimeout) clearTimeout(this.$store.state.checkoutExpiryTimeout);
      this.$store.state.checkoutExpiryTimeout = null;
    },

    async sendOrderToServer(messagePrompt = true) {
      let sendResult = {
        result: "failed",
        referenceID: "",
        message: "",
        messageCode: "",
      };

      // debug - begin
      //sendResult.messageCode = "error_send_incorrect_order";
      // debug - end

      let canSendOrder = true;
      // redeem points
      if (this.$store.state.member && this.$store.getters.pointEnabled) {
        if (this.$store.state.Order.order.redeemedPointsTotal > 0) {
          let res = await mMember.redeemMemberPoints(
            this.$store.state.member.MemberCode,
            this.$store.state.Order.order.redeemedPointsTotal
          );
          if (res.result != "ok" && this.$store.state.Order.order.payAmount == 0) {
            if (res.result == "non-sufficient points") {
              sendResult.messageCode = "error_non_sufficient_points";
            } else {
              sendResult.messageCode = "error_point_redeem";
            }

            canSendOrder = false;
          }
        }
      }

      // redeem promo
      if (canSendOrder) {
        let promoOi = this.$store.state.Order.order.orderItems.find(oi => oi.promo);
        if (promoOi) {
          let res = await mMember.redeemMemberPromo(this.$store.state.member.MemberCode, promoOi.promo);
          if (res.result != "ok" && this.$store.state.Order.order.payAmount == 0) {
            let promoTitle = promoOi.promo.title;
            if (this.$store.state.descrIndex == 1) promoTitle = promoOi.promo.title1;
            else if (this.$store.state.descrIndex == 2) promoTitle = promoOi.promo.title2;
            sendResult.message = this.$t("error_promo_redeemed", {
              promo: promoTitle,
            });
            canSendOrder = false;
          }
        }
      }

      if (canSendOrder) {
        let feed = mOrder.orderToFeed();
        if (feed == null) {
          sendResult.messageCode = "error_send_incorrect_order";
        } else if (feed.items.length > 0) {
          let orderType = this.$store.state.Order.order.orderType;
          let res = await mRest.sendOrder(feed);
          if (res.result == "ok") {
            if (res.doorDash) this.$set(this.$store.state.Order.order, "doorDash", res.doorDash);

            sendResult.result = res.result;
            sendResult.referenceID = res.referenceID;

            feed.referenceID = res.referenceID;

            let message = this.$t("order_reference_no") + "</h3><h1>" + res.referenceID + "</h1>";
            let timeZoneAbbrev = "";
            if (!this.$store.getters.storeTimeZoneMatched && this.$store.getters.storeTimeZoneAbbrev != "")
              timeZoneAbbrev = " (" + this.$store.getters.storeTimeZoneAbbrev + ")";
            if (orderType == ORDER_TYPE.TAKEOUT) {
              let pickupTime = mUtils.toLocaleString(this.$store.state.Order.order.pickupTime);
              let pickupAt = this.$store.getters.checkoutPickupTimeIgnored
                ? ""
                : "<br>" + this.$t("checkout.pickup_at") + "<br>" + pickupTime + timeZoneAbbrev + "<br>";
              message +=
                pickupAt +
                "<br>" +
                this.$t("pickup_address") +
                "<br>" +
                this.$store.getters.storeName +
                "<br>" +
                this.storeAddressString;
            } else if (orderType == ORDER_TYPE.DELIVERY) {
              let deliveryTime = mUtils.toLocaleString(this.$store.state.Order.order.deliveryTime);
              if (this.$store.state.Order.order.deliveryTimeTo)
                deliveryTime += " - " + mUtils.toLocaleTimeString(this.$store.state.Order.order.deliveryTimeTo);
              let deliveryAt = this.$store.getters.checkoutPickupTimeIgnored
                ? ""
                : "<br>" + this.$t("checkout.delivery_at") + "<br>" + deliveryTime + timeZoneAbbrev + "<br>";
              message += deliveryAt + "<br>" + this.$t("delivery_address") + "<br>" + this.deliveryAddressString;
            }
            message += "<br><br>" + this.$t("checkout.review_order");

            if (messagePrompt) mDialog.messageDialog.open(this.$t("order_successful"), "", "<h3>" + message);

            try {
              let memberCode = null;
              if (this.$store.state.member) memberCode = this.$store.state.member.MemberCode;
              mMember.updateMemberPromos(memberCode);
              this.addOrderHistory(res.referenceID);
              mOrder.clearOrder();

              this.clearCheckoutExpiryTimer();

              mAnalytics.logPurchases(feed);
            } catch (error) {
              console.log(error);
            }
          } else {
            sendResult.message = res.message;
          }
        } else {
          sendResult.messageCode = "error_send_empty_order";
        }
      }

      if (sendResult.result != "ok") {
        let errorMessage = this.$t("error_send_order_11");
        if (sendResult.messageCode != "") errorMessage = this.$t(sendResult.messageCode);
        if (sendResult.message != "") errorMessage = sendResult.message;

        if (messagePrompt) mDialog.messageDialog.open(this.$t("error_alert_title"), "", errorMessage);
      }

      return sendResult;
    },
  },
};
